import * as React from 'react'

const MenuColumnsIcon = (props: { className?: string }) => {
  const classname = props.className ? `icon ${props.className}` : ''
  return (
    <svg
      className={classname}
      width='24'
      height='28'
      viewBox='0 0 24 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='4.66667' height='28' rx='1' transform='translate(16.333)' fill='#666666' />
      <rect width='4.66667' height='28' rx='1' transform='translate(8.16699)' fill='#666666' />
      <rect width='4.66667' height='28' rx='1' transform='translate(8.16699)' fill='#666666' />
      <rect width='4.66667' height='28' rx='1' fill='#666666' />
    </svg>
  )
}

export default MenuColumnsIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/MenuColumns.tsx